import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import { useEffect } from "react";
import { trackTelegramClick } from "./utils/promoStats";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function TelegramTracker() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get('utm_source');
    if (utmSource === 'telegram') {
      const pathParts = window.location.pathname.split('/');
      const storeIdx = pathParts.indexOf('store');
      const storeSlug = storeIdx !== -1 ? pathParts[storeIdx + 1] || '' : '';
      trackTelegramClick({
        storeName: storeSlug,
        storeSlug,
        promoCode: decodeURIComponent(params.get('utm_content') || ''),
        utmCampaign: params.get('utm_campaign') || '',
        referrer: document.referrer,
      });
      // Clean UTM params from URL without reload
      params.delete('utm_source');
      params.delete('utm_medium');
      params.delete('utm_campaign');
      params.delete('utm_content');
      const cleanUrl = params.toString()
        ? `${window.location.pathname}?${params.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    }
  }, []);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <TelegramTracker />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
